import React from "react";

import { ScaledContainer } from "./components/scaled-container/ScaledContainer";

import styles from "./Layout.module.css";

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className={styles.layoutWrapper}>
      <div className={styles.aspectRatioContainer}>
        <ScaledContainer className={styles.scaledContent}>
          <div className={styles.contentWrapper}>
            <div className={styles.mainColumn}>{children}</div>
          </div>
        </ScaledContainer>
      </div>
    </div>
  );
};
